import { axiosRequest } from '@/util/axios-request'

// 新增方案
export const saveProject = data =>
  axiosRequest({
    url: '/web/payroll_sub_project_scheme/save',
    method: 'POST',
    params: data
  })

// 获取结算类型
export const getTypeList = data =>
  axiosRequest({
    url: '/web/payroll_sub_project_scheme/getTypeList',
    method: 'GET',
    params: data
  })

// 获取子项目列表
export const getList = data =>
  axiosRequest({
    url: '/web/payroll_sub_project_scheme/getList',
    method: 'POST',
    params: data
  })

// 项目考勤数据
export const getAttendance = data =>
  axiosRequest({
    url: '/web/payroll_rule/get_attendance',
    method: 'POST',
    params: data
  })

// 删除方案
export const delScheme = data =>
  axiosRequest({
    url: '/web/payroll_sub_project_scheme/delete',
    method: 'POST',
    params: data
  })

// 获取计薪方案
export const getListBySubId = data =>
  axiosRequest({
    url: '/web/payroll_sub_project_scheme/getListBySubId',
    method: 'POST',
    params: data
  })
